import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserBlock: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user-block, people, person, member, blocked"><path d="M12 20.25H4.75V19.5C4.75 15.4959 7.99594 12.25 12 12.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="18" cy="17.25" r="3.5" stroke="currentColor" strokeWidth="1.5"/><path d="M15.7461 19.5L20.2461 15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconUserBlock;
